import styled from "styled-components";

export const StyledLayout = styled.div`

  a {
    color: ${props => props.theme.linksColor} !important;
  }

  button.ant-btn-primary {
    background: ${props => props.theme.buttonColor} !important;    
  }

  .button-color {
    background: ${props => props.theme.buttonColor} !important;    
  }

  .ant-btn-link {
    color: ${props => props.theme.linksColor} !important;
  }

  .link-color {
    color: ${props => props.theme.linksColor} !important;
  }

  body > a {
    color: ${props => props.theme.linksColor} !important;
  }
`;

export const StyledHeader = styled.div`
  width: 100%;
  height: 50px;
  background: white;
  box-shadow: 5px 0px 10px grey;
`;

